import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/IntellScheduling/banner_inner.png'
import _imports_1 from '@/assets/IntellScheduling/company_problem.png'
import _imports_2 from '@/assets/IntellScheduling/advantage01.png'
import _imports_3 from '@/assets/IntellScheduling/advantage02.png'
import _imports_4 from '@/assets/IntellScheduling/advantage03.png'
import _imports_5 from '@/assets/IntellScheduling/advantage04.png'
import _imports_6 from '@/assets/IntellScheduling/advantage05.png'
import _imports_7 from '@/assets/IntellScheduling/advantage06.png'
import _imports_8 from '@/assets/IntellScheduling/product_value_bg.png'
import _imports_9 from '@/assets/IntellScheduling/app_code.png'


const _withScopeId = n => (_pushScopeId("data-v-388f125a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intell-schedu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "f36 f_bold center" }, "租车管理系统"),
  /*#__PURE__*/_createElementVNode("div", { class: "f12 center" }, "租车派单、司机任务分发、交收车全流程记录管控"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "problem-bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "problem-bg",
    alt: ""
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "problem-b" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "problem-b-title" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f24 f_bold f_white" }, "租车管理系统，用车流程全覆盖")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "problem-b-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "problem-b-item" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "f16 f_bold" }, "01订单录入"),
      /*#__PURE__*/_createElementVNode("div", { class: "main-explain" }, [
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "用车订单一键录入"),
          /*#__PURE__*/_createElementVNode("li", null, "租车、包车多种场景"),
          /*#__PURE__*/_createElementVNode("li", null, "支持证件拍照识别"),
          /*#__PURE__*/_createElementVNode("li", null, "贴心提醒同事功能")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "problem-b-item" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "f16 f_bold" }, "02派车派司机"),
      /*#__PURE__*/_createElementVNode("div", { class: "main-explain" }, [
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "车辆排班实时总览"),
          /*#__PURE__*/_createElementVNode("li", null, "位置信息微信/短信分享给客户"),
          /*#__PURE__*/_createElementVNode("li", null, "一键智能派车派司机"),
          /*#__PURE__*/_createElementVNode("li", null, "交收车里程、油量、费用拍照留痕")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "problem-b-item" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "f16 f_bold" }, "03行程监控"),
      /*#__PURE__*/_createElementVNode("div", { class: "main-explain" }, [
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "车辆实时位置监控"),
          /*#__PURE__*/_createElementVNode("li", null, "车辆油耗监控"),
          /*#__PURE__*/_createElementVNode("li", null, "车辆超速报警"),
          /*#__PURE__*/_createElementVNode("li", null, "电子围栏预警"),
          /*#__PURE__*/_createElementVNode("li", null, "车辆碰撞报警")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "problem-b-item" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "f16 f_bold" }, "04结算分析"),
      /*#__PURE__*/_createElementVNode("div", { class: "main-explain" }, [
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "一键导出行程对账单"),
          /*#__PURE__*/_createElementVNode("li", null, "根据车型搜索订单数据"),
          /*#__PURE__*/_createElementVNode("li", null, "公司经营数据一目了然")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_5 = { class: "advantage" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "advantage-title f24 f_bold center" }, "解决企业用车核心难题", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swipe-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-next" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f20 f_bold center" }, "1分钟完成一个订单调度"),
    /*#__PURE__*/_createElementVNode("div", { class: "f16 center f_submain" }, "智能排班 灵活调度"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "下单、调度、交车、收车、结算全流程业务节点高效管理"),
      /*#__PURE__*/_createElementVNode("li", null, "一车一档案，出租、空闲、维修、预订... 当前车辆状态自动匹配")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "href" }, "车辆调度")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swipe-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-next" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f20 f_bold center" }, "灵活分配员工权限"),
    /*#__PURE__*/_createElementVNode("div", { class: "f16 center f_submain" }, "一套系统，公司多种员工角色全覆盖"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "业务（管理公司订单及客户数据,风控查询）、车管（车辆资产管理,维修保养年检提醒）、 司机（任务接收,快捷交收车）、财务（对账,核算公司经营数据）、老板（手机查看经 营报表）")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "href" }, "员工管理")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swipe-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-next" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f20 f_bold center" }, "多客户匹配分类报价"),
    /*#__PURE__*/_createElementVNode("div", { class: "f16 center f_submain" }, "建立分类价格体系，轻松维护客户"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "多渠道线索统一管理，自定义客户标签，深度经营企业客户资产"),
      /*#__PURE__*/_createElementVNode("li", null, "针对不同客户类型，可建立多类价格模板，灵活管理客户成员")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "href" }, "客户管理")
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swipe-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-next" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f20 f_bold center" }, "车辆在哪里，客人早知晓"),
    /*#__PURE__*/_createElementVNode("div", { class: "f16 center f_submain" }, "车辆位置司乘实时共享"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "行程信息可通过微信/短信方式分享给客户"),
      /*#__PURE__*/_createElementVNode("li", null, "有效避免因司机送车迟到、送错地址等引起的扯皮、投诉")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "href" }, "位置共享")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swipe-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-next" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f20 f_bold center" }, "保障人车行程安全"),
    /*#__PURE__*/_createElementVNode("div", { class: "f16 center f_submain" }, "全程人防+技防，筑牢行程风控"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "行程前：风控查询甄别风险客户，有效防骗租、防丢车"),
      /*#__PURE__*/_createElementVNode("li", null, "行程中：GPS关联订单，对车辆位置即时追踪、实时预警、高效响应")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "href" }, "人车安全")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swipe-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-next" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "f20 f_bold center" }, "经营数据，全局掌握"),
    /*#__PURE__*/_createElementVNode("div", { class: "f16 center f_submain" }, "可视化数据分析，辅助智能决策"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "用车、行驶、车务数据多维度呈现，单车收益和账目明细可视化呈现"),
      /*#__PURE__*/_createElementVNode("li", null, "经营状况全流程管控，决策科学更省心，帮你把生意做得更好")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "href" }, "数据分析")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-value" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "product-value-title f24 f_bold center" }, "数字化管理，为企业增效降本"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: ""
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "download-app" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "download-app-item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_9,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("p", { class: "f24 f_bold" }, "手机基础版"),
    /*#__PURE__*/_createElementVNode("div", { class: "f_light" }, "随时随地，轻松调派")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      scrollspy: "",
      sticky: "",
      "offset-top": "2.02rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "企业痛点" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "产品介绍" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "产品优势" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_van_swipe, { class: "my-swipe" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "产品价值" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _hoisted_14
  ]))
}